import {FormReducer} from 'state/reducers/form'
import {assoc} from 'ramda'

export const formType: FormReducer = (state, {payload}) => assoc('appType', payload, state)
